// =====================================================
// Companies — preloaded list. Scalable to 10 bolag.
// =====================================================

export interface Company {
  id: string
  name: string
  /** Organisationsnummer (valfritt tills du lägger in det) */
  orgNr?: string
  /** "Förening" | "AB" | "HB" | "EF" */
  type: 'AB' | 'Förening' | 'HB' | 'EF'
  /** Momsperiod: 'monthly' | 'quarterly' | 'yearly' */
  vatPeriod?: 'monthly' | 'quarterly' | 'yearly'
}

export const COMPANIES: Company[] = [
  { id: 'occdec',    name: 'OCCDEC AB',                   type: 'AB',       vatPeriod: 'quarterly' },
  { id: 'linesp-ab', name: 'Linespotting AB',             type: 'AB',       vatPeriod: 'quarterly' },
  { id: 'linesp-fo', name: 'Linespotting Incubator',      type: 'Förening', vatPeriod: 'yearly'    },
]

/** Max antal bolag som UI är förberett för. */
export const MAX_COMPANIES = 10
